<div class="pt-2">
  <ul class="list-unstyled row g-3">
    @for (item of listMenuItems; track $index) {
    <li (click)="routeTo(item.patch)" class="col-12 col-sm-6 col-md-4 col-lg-3">
      <div
        class="card position-relative text-center shadow border-0 p-3 pt-4 pb-4 h-100 transition-scale hover-shadow overflow-hidden cursor"
      >
        <div class="d-flex justify-content-center align-items-center mb-3">
          <i class="bi {{ item.icon }}"></i>
        </div>
        <h5 class="text-secondary mb-2">{{ item.title | transloco }}</h5>
        <div
          class="menu-ellipse cursor position-absolute d-flex justify-content-center align-items-center top-0 end-0 rounded-circle"
        >
          <div class="menu-corner position-absolute"></div>
        </div>
      </div>
    </li>
    }
  </ul>
</div>
